import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class OnlineBookingActivity extends Component {
    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Hospitality/OnlineBooking/OnlineBookingHistoryBrowser")
    }

    render() {
        return (
            <Activity 
                name="CheckedOut"
                context="OnlineBookingFinished"
                RenderedComponent={this.RenderedComponent}
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(OnlineBookingActivity)
